import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["sendButton", "loader", "sentConfirmation"]

  connect() {
    // optional: console log to verify connection
    // console.log("SendMessageController connected");
  }

  showLoader(event) {
    event.preventDefault();
    
    const button = event.currentTarget;
    const container = this.element;

    if (!container) return;

    const loader = container.querySelector(".send-loader");
    // const sentInfo = container.querySelector(".sent-confirmation");

    // if (sentInfo) sentInfo.classList.add("hidden");
    if (loader) loader.classList.remove("hidden");

    button.classList.add("hidden");
  }
}
